import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import HomePage from './pages/HomePage';
import ServisPage from './pages/ServisPage';
import KontaktPage from './pages/KontaktPage';
import GdprPage from './pages/GdprPage';
import OchranaUdajovPage from './pages/OchranaUdajovPage';
import CookiesPage from './pages/CookiesPage';
import AccessibilityWidget from './components/AccessibilityWidget';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-tech-dark">
        <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:bg-accent-green focus:text-black focus:px-4 focus:py-2 focus:rounded-lg focus:font-semibold">
          Skip to main content
        </a>
        <Header />
        <main id="main-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/servis" element={<ServisPage />} />
          <Route path="/kontakt" element={<KontaktPage />} />
          <Route path="/gdpr" element={<GdprPage />} />
          <Route path="/ochrana-udajov" element={<OchranaUdajovPage />} />
          <Route path="/cookies" element={<CookiesPage />} />
        </Routes>
        </main>
        <Footer />
        <CookieConsent />
        <AccessibilityWidget />
      </div>
    </Router>
  );
}

export default App;
